import { Agency } from '@app/models/agency';
import { DictionaryEntity } from '@app/pcs/models/dictionary-entity';
import { LocoTypeNumber, locoTypeNumberDetailed } from '@app/pcs/models/loco-type-number';
import {gql} from 'apollo-angular';

export interface LocoType {
  id?: number;
  ttpId?: number;
  agency?: Agency;
  locoTypeNumber?: LocoTypeNumber;
  nationalId?: string;
  explanation?: string;
  weight?: number;
  length?: number;
  tractionMaxSpeed?: number;
  relatedPerformance?: number;
  typeOfEngine?: DictionaryEntity;
  trainCcSystems?: DictionaryEntity[];
}

export const locoTypeDetailed = gql`
  fragment locoTypeDetailed on LocoType {
    id
    ttpId
    agency {
      id
      name
      shortName
    }
    locoTypeNumber {
      ...locoTypeNumberDetailed
    }
    nationalId
    explanation
    weight
    length
    tractionMaxSpeed
    relatedPerformance
    typeOfEngine {
      id
      description
    }
    trainCcSystems {
      id
      description
    }
  }
  ${locoTypeNumberDetailed}
`;

export enum LocoTypePropertyMap {
  LocoTypeNumber = 'locoTypeNumber',
  NationalId = 'nationalId',
  Explanation = 'explanation',
  Weight = 'weight',
  Length = 'length',
  TractionMaxSpeed = 'tractionMaxSpeed',
  TypeOfEngine = 'typeOfEngine',
  RelatedPerformance = 'relatedPerformance'
}

export enum LocoTypeNumberPropertyMap {
  TypeOfLoco = 'typeOfLoco',
  LocoCountry = 'country',
  SeriesNumber = 'seriesNumber',
  SerialNumber = 'serialNumber',
}
